export default __webpack_public_path__ + "static/media/patient_id.8f349393.svg";